export var createEmptyAddOnService = function (uuid) { return ({
    uuid: uuid(),
    name: "",
    price: 0,
    active: true,
    destroyable: true,
    olbEnabled: false,
    taxes: []
}); };
